import { useAtom } from 'jotai';
import { twJoin } from "tailwind-merge"
import atomsVersion from './atoms/version'

const IconWarning = () => (
  <svg viewBox="0 0 16 16" height="16" width="16" data-slot="warning-icon">
    <path fill="currentColor" d="M8.56.5c.57 0 1.1.33 1.35.85l5.9 12.22a1 1 0 0 1-.9 1.43H1.09a1 1 0 0 1-.9-1.43L6.1 1.35A1.5 1.5 0 0 1 7.44.5zm-6.67 13h12.22L8.56 2H7.44zM8 10a1 1 0 1 1 0 2 1 1 0 0 1 0-2m.75-1.25h-1.5v-4h1.5z"/>
  </svg>
)

const VersionBanner = ({className: classNameTail=''}) => {
  
  const [searchVersion] = useAtom(atomsVersion)
  
  if (process.env.NEXT_PUBLIC_SUPPORT_VERSION_SELECTOR !== 'true') return ''
  if (searchVersion !== 'v1') return ''
  
  return (
    <div
      className={twJoin(
        "bg-yellow-100 py-2 px-3",
        "flex grow items-start",
        "sm:flex-row sm:items-center sm:gap-3 gap-2",
        "min-h-10 rounded-md text-sm leading-normal break-words box-border",
        "[&_svg]:!h-[1lh] text-left",
        classNameTail
      )}>
      <span
        className={"text-amber-900"}
      >
        <IconWarning/>
      </span>
      <span>
        <span className={"text-amber-900"}>You are currently viewing documentation for v{ searchVersion === 'v1' ? '1.0' : '2.0' } of Traqq.</span>
        <span className={"text-amber-900"}><a href='/support'> Traqq v{ searchVersion === 'v1' ? '2.0' : '1.0' } documentation is here →</a></span>
      </span>
    </div>
  )
}

export default VersionBanner
